import { render, staticRenderFns } from "./Hexagon.vue?vue&type=template&id=2749a3ea&scoped=true&"
import script from "./Hexagon.vue?vue&type=script&lang=js&"
export * from "./Hexagon.vue?vue&type=script&lang=js&"
import style0 from "./Hexagon.vue?vue&type=style&index=0&id=2749a3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749a3ea",
  null
  
)

export default component.exports